module.exports = __webpack_public_path__ + "jpex-inverse.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpex-inverse.svg
// module id = 30
// module chunks = 0